<template>
  <div style="height: 100%" v-loading="showLoading" :element-loading-text="percent"
    element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
    <!-- <van-button type="primary" text="显示遮罩层" @click="show = true" /> -->
    <van-overlay :show="show" v-if="isShow" />
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <router-link :to="{ path: '/' }">
            <span style="color: #4a90e2">
              <i class="el-icon-location"></i>
              {{ $t('allExcelData.首页') }}
            </span>
          </router-link>
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t('allExcelData.数据批量导出') }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div id="form">
      <div style="white-space: nowrap;" class="sxtj">{{ $t('allExcelData.筛选条件') }}</div>
      <div class="choose">
        <div class="choosedata">
          <el-tree :data="groupArrCopyCopy" :props="defaultProps" show-checkbox
            @check-change="handleCheckChange"></el-tree>
        </div>
      </div>
      <div class="riqi">
        <el-date-picker v-model="dbt" type="date" :placeholder="$t('allExcelData.数据开始日期')"
          value-format="yyyy-MM-dd"></el-date-picker>
        {{ $t('allExcelData.至') }}
        <el-date-picker v-model="edt" type="date" :placeholder="$t('allExcelData.数据结束日期')"
          value-format="yyyy-MM-dd"></el-date-picker>
      </div>
      <div class="daochu">
        <el-button type="primary" @click="getExecl">{{ $t('allExcelData.批量导出') }}</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast, Overlay } from 'vant'
import FileSaver from 'file-saver' //https://stuk.github.io/jszip/
import JSZip from 'jszip' //https://github.com/eligrey/FileSaver.js/
import moment from 'moment'
import { myequips, sharedequips, equiphistory, equipinfo } from '../service/getData'
import { Message } from 'element-ui'
export default {
  name: 'allExcelData',
  components: {
    [Overlay.name]: Overlay,
  },
  data() {
    return {
      show: false,
      isShow: false,
      //导出进度
      percent: '',
      //数据开始日期
      pickerOptionsStart: {
        disabledDate: (time) => {
          let endDateVal = this.daterangeend
          if (endDateVal) {
            return time.getTime() > new Date(endDateVal).getTime() || time.getTime() > Date.now()
          }
        },
      },
      //数据结束日期
      pickerOptionsEnd: {
        disabledDate: (time) => {
          let beginDateVal = this.daterange
          if (beginDateVal) {
            return time.getTime() < new Date(beginDateVal).getTime() - 1 * 24 * 60 * 60 * 1000 || time.getTime() > Date.now()
          }
        },
      },
      daterange: '',
      daterangeend: '',
      // 开始时间
      dbt: null || moment().subtract(1, 'year').format('YYYY-MM-DD'),
      // 结束时间
      edt: null || moment().format('YYYY-MM-DD'),
      sharedequips: null,
      groupArr: null,
      groupArrCopy: [],
      groupArrCopyCopy: [],
      //树形选择
      defaultProps: {
        children: 'children',
        label: 'label',
      },
      //需要传给后台接口的导出表格的数据的id
      idArray: [],
      //全选时的ID
      temp: [],
      showLoading: false,
      loading: '',
      percent1: '',
      //
      equipHead: null,
      equipinfoList1: [],
      json_data: null,
      json_fields: {
        'Complete name': 'name',
        Date: 'date',
      },
      tHeader1: [],
      excelName:
        `${this.equipmentnm}-${this.equipmentno}-${moment(this.dbt).format('YYYYMMDD')}-${moment(this.edt).format('YYYYMMDD')}.xls` || '设备报表.xls',
      fileList: [],
    }
  },
  methods: {
    //resList是异步请求的json对象集合数组，每个文件对象要有个Key，描述单个文件的名字
    patchExport() {
      var zip = new JSZip()
      // resultArr.forEach(el => {
      //   let equip = equipArr.filter(x => x.driveId == el.driveId)[0]
      //   const stringXml = this.joinStringXml(el, equip)
      //   zip.file(el.driveName + '.xlsx', stringXml)
      // })

      const { export_json_to_excel } = require('../vender/Export2Excel2')

      for (let i = 0; i < this.fileList.length; i++) {
        console.log('i>>>', i)
        // export_json_to_excel(
        //   this.fileList[i].tHeader,
        //   this.fileList[i].data3,
        //   this.fileList[i].excelName
        // )
        zip.file(
          this.fileList[i].excelName + '.xlsx',
          export_json_to_excel(this.fileList[i].tHeader, this.fileList[i].data3, this.fileList[i].excelName)
        )
      }

      zip.generateAsync({ type: 'blob' }).then(function (content) {
        //console.log('content>>>', content)
        FileSaver.saveAs(content, 'bigfloats.zip')
      })
      //导出进度
      let _this = this
      zip.generateAsync({ type: 'blob' }, function updateCallback(metadata) {
        _this.percent = _this.$t('allExcelData.压缩中') + metadata.percent.toFixed(2) + ' %'
        _this.showLoading = true
        _this.show = true
        _this.isShow = true
        if (metadata.percent.toFixed(2) == '100.00') {
          _this.showLoading = false
          _this.show = false
          _this.isShow = false
        }

        _this.loading.close()
      })
    },
    //获得选择的设备id
    getSelectOption() {
      this.idArray = []
      if (this.groupArrCopyCopy[0].isChoose == '1') {
        //需要传给后台接口的导出表格的数据的id
        this.idArray = this.temp
        //console.log('idArray>>', this.idArray)
      } else {
        for (let i = 0; i < this.groupArrCopyCopy[0].children.length; i++) {
          for (let j = 0; j < this.groupArrCopyCopy[0].children[i].children.length; j++) {
            if (this.groupArrCopyCopy[0].children[i].isChoose == '1') {
              const obj = this.groupArrCopyCopy[0].children[i].children[j]
              this.idArray.push({ driveId: obj.equipid, driveName: obj.label })
              // console.log('idArray000>>', this.idArray)
            } else {
              if (this.groupArrCopyCopy[0].children[i].children[j].isChoose == '1') {
                const obj = this.groupArrCopyCopy[0].children[i].children[j]
                this.idArray.push({
                  driveId: obj.equipid,
                  driveName: obj.label,
                })
                // console.log('idArray1111>>', this.idArray)
              }
            }
          }
        }
      }
    },
    async change(v) {
      if (v != null && v.length != 0) {
        this.dbt = this.daterange
        this.edt = this.daterangeend
      }
    },
    async myequips_sharedequips() {
      let result = await myequips()
      let data = result.data

      let type = []

      data.map((n) => {
        if (!type.includes(n.equiptypeid)) {
          type.push(n.equiptypeid)
        }
      })

      let groupArr = []
      for (let i = 0; i < type.length; i++) {
        data.map((n) => {
          if (n.equiptypeid == type[i]) {
            if (!groupArr[i]) {
              groupArr[i] = {
                name: n.equiptypenm,
                items: [],
              }
            }
            groupArr[i].items.push(n)
          }
        })
      }
      this.groupArr = groupArr

      //更改key值
      this.groupArrCopy = []
      this.groupArr.map((value) => {
        this.groupArrCopy.push({
          label: value.name,
          children: value.items,
        })
      })
      //将所有数据的id存起来
      this.temp = []
      for (let i = 0; i < this.groupArrCopy.length; i++) {
        this.groupArrCopy[i].isChoose = ''
        for (let j = 0; j < this.groupArrCopy[i].children.length; j++) {
          this.groupArrCopy[i].children[j].label = this.groupArrCopy[i].children[j].equipmentnm
          this.groupArrCopy[i].children[j].children = []
          this.groupArrCopy[i].children[j].isChoose = ''
          this.temp.push({
            driveId: this.groupArrCopy[i].children[j].equipid,
            driveName: this.groupArrCopy[i].children[j].label,
          })
        }
      }

      this.groupArrCopyCopy = [
        {
          label: this.$t('allExcelData.全选'),
          children: this.groupArrCopy,
          isChoose: '',
        },
      ]
      let result2 = await sharedequips()
      let data2 = result2.data
      this.sharedequips = data2
    },
    handleCheckChange(data, checked) {
      if (checked == true) {
        data.isChoose = '1'
      } else {
        data.isChoose = '0'
      }
    },

    //待处理:  3.特殊字符转义 4.分割文件 5.进度显示  8.单独下载 9.限制时间 10.分包下载按钮 11.计算时间判断超时 12.页面布局调整
    async getExecl() {
      this.getSelectOption()
      console.log(this.idArray)
      if (this.idArray.length <= 0) {
        Toast(this.$t('allExcelData.请选择导出内容'))
        return
      }
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      console.log(this.loading)
      this.showLoading = true
      // this.loading.setText(this.$t('allExcelData.正在导出'))
      this.fileList = []
      const errorList = []
      for (let i = 0; i < this.idArray.length; i++) {

        let result2
        try {
          result2 = await equiphistory(this.dbt, this.edt, this.idArray[i].driveId, 1, 60000)
        } catch (error) {
          errorList.push(this.idArray[i].driveId)
          continue
        }
        let result = await equipinfo(this.idArray[i].driveId)
        //let data = result1.data
        this.equipHead = result.data
        this.excelName = `${this.idArray[i].driveName}-${moment(this.dbt).format('YYYYMMDD')}-${moment(this.edt).format('YYYYMMDD')}`
        require.ensure([], () => {
          // const { export_json_to_excel } = require('../vender/Export2Excel')
          var tHeader = [this.$t('allExcelData.时间'), this.$t('allExcelData.经度'), this.$t('allExcelData.纬度')]
          var filterVal = ['createtime', 'jdt', 'wdt']
          var tHeader1 = []
          var filterVal1 = []
          // 循环头部
          this.equipHead.tp.map((n, index) => {
            tHeader1[index] = n
          })
          // 循环tHeader1里面的tnm
          this.tHeader1 = tHeader1
          tHeader1.map((v) => {
            return v.tnm
          })
          //循环出来的tnm重新组成一个tHeader2数组
          let tHeader2 = tHeader1.map((v) => {
            return v.tnm
          })
          //循环出来equipinfoList里面的数据

          let equipinfoList = JSON.parse(result2.data.data)
          console.log(i, '>>>>>>', this.idArray.length, this.idArray, equipinfoList)
          //导出进提示
          this.percent = this.$t('allExcelData.正在导出') + ((i / this.idArray.length) * 100).toFixed(2) + ' %'
          this.showLoading = true

          this.loading.close()
          this.show = true
          this.isShow = true
          //结束
          if (equipinfoList !== '') {
            equipinfoList.map((n, index) => {
              filterVal1[index] = n
            })
            var a = []
            let data = result.data
            for (let i = 0; i < data.tp.length; i++) {
              a.push('col' + i)
            }
            var filterVal2 = [].concat(a)
            Array.prototype.push.apply(tHeader, tHeader2)
            Array.prototype.push.apply(filterVal, filterVal2)
            const data3 = this.formatJson(filterVal, equipinfoList)
            this.fileList.push({
              tHeader: tHeader,
              data3: data3,
              excelName: this.excelName,
            })
          }
        })
      }

      // console.log('fileList>>>', this.fileList)
      setTimeout(() => {
        this.patchExport()
        if (errorList.toString()) {
          Message({
            message: this.$t('allExcelData.问题数据') + errorList.toString(),
          })
        }
        console.error(this.$t('allExcelData.问题数据') + errorList.toString())
      }, 1000)
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => {
        return filterVal.map((j) => {
          return v[j]
        })
      })
    },
  },
  mounted() {
    this.myequips_sharedequips()
  },
}
</script>
<style lang="scss" scoped>
#form {
  background: white;
  height: 90%;
  padding-top: 10px;

  .sxtj {
    width: 100px;
    margin-left: 20px;
  }

  .choose {
    margin-left: 25px;
    margin-top: 15px;
    width: 400px;
    height: calc(100vh - 321px);
    background-color: white;
    border: 1px solid #e6e6eb;
    border-radius: 4px;
    overflow-y: auto;
    padding-bottom: 10px;

    .choosedata {
      margin-left: 15px;
      margin-top: 10px;
    }
  }

  .riqi {
    margin-left: 25px;
    margin-top: 15px;
  }

  .daochu {
    margin-left: 25px;
    margin-top: 15px;
  }
}

.jindu {
  position: absolute;
  //background-color: ;
  width: 200px;
  height: 50px;
  margin-top: -250px;
  margin-left: 400px;
  font-size: 16px;
  color: black;
  text-align: center;
}
</style>
<style>
.van-overlay {
  display: inherit !important;
  z-index: 10 !important;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
}
</style>
